import { EDIT_USER_TYPES, EDIT_USER_TYPES_ERROR, EDIT_USER_TYPES_SUCCESS, USER_TYPES_DETAILS_ERROR, USER_TYPES_LIST, USER_TYPES_LIST_DETAILS, USER_TYPES_LIST_DETAILS_SUCCESS, USER_TYPES_LIST_ERROR, USER_TYPES_LIST_SUCCESS } from './constants';



export default function usertypereducer(state, action) {
    
	let userTypes = [];
	

	switch (action.type) {

	case USER_TYPES_LIST:
		return { ...state, loading: true };
	
	case USER_TYPES_LIST_SUCCESS:
			
	
		if (action.payload && action.payload.data && action.payload.data.length > 0) {
			action.payload.data.map( (item) => {
				let data = {};
	
				data.id = item.id ? item.id : 0;
				data.userType = item.userType ? item.userType : '';
				data.createdAt = item.createdAt ? item.createdAt : '';
				data.updatedAt = item.updatedAt ? item.updatedAt : '';
				data.aliasName = item.aliasName ? item.aliasName : '';
	
				return userTypes.push(data);
			});
	
			return { ...state, userTypes: userTypes, loading: false, error: false };
		} else {
			if (action.payload && action.payload.data && action.payload.data.length === 0) {
				return { ...state, userTypes: userTypes, loading: false, error: false };
			} else {
				return { ...state, loading: false, error: true };
			}
		}
	
	case USER_TYPES_LIST_ERROR:
		return { ...state, loading: false, error: true };
	

	case EDIT_USER_TYPES:
		return { ...state, loading: true, error: false };

	case EDIT_USER_TYPES_SUCCESS:
		return { ...state,  loading: false, error : false };

	case EDIT_USER_TYPES_ERROR:
		return {...state, loading : false, error : true};

	case USER_TYPES_LIST_DETAILS:
		return { ...state, loading: true };

	case USER_TYPES_LIST_DETAILS_SUCCESS:
		return { ...state, loading: false, details:action.payload, error: false };

	case USER_TYPES_DETAILS_ERROR:
		return { ...state, loading: false, error: true };

	default: 
		throw Error('Unknown action: ' + action.type);
      
	}
}